"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOptionPoolParams = exports.OptionPoolIdSchema = exports.OptionPoolPatchSchema = exports.OptionPoolPostSchema = void 0;
const yup_1 = require("yup");
const enums_1 = require("../contracts/enums");
const constants_1 = require("../constants");
const REQUIRED_FIELD_MESSAGE = "This is a required field.";
const numberRequired = (message = "Param must be a number") => (0, yup_1.number)()
    .transform((v) => (!Number.isNaN(+v) && typeof +v === "number" ? +v : undefined))
    .positive()
    .required(message);
exports.OptionPoolPostSchema = (0, yup_1.object)({
    name: (0, yup_1.string)()
        .trim()
        .required(REQUIRED_FIELD_MESSAGE)
        .matches(constants_1.ALPHANUMERIC_REGEX_WITH_SPACE, "Options pool name must be alphanumeric value only")
        .max(20, "Maximum character limit: 20"),
    optiongrantIds: (0, yup_1.mixed)().oneOf([undefined, null]),
    shareclassId: (0, yup_1.string)().trim().required(REQUIRED_FIELD_MESSAGE),
    totalOptions: numberRequired("Total options must be a number"),
    code: (0, yup_1.string)()
        .required("Code can not be empty")
        .matches(constants_1.ALPHANUMERIC_REGEX, "Code must be alphanumeric")
        .min(2, "Code should be at least 2 characters")
        .max(4, "Code can not exceed 4 characters"),
});
exports.OptionPoolPatchSchema = (0, yup_1.object)({
    totalOptions: numberRequired("Total options must be a number"),
});
exports.OptionPoolIdSchema = (0, yup_1.object)({
    optionPoolId: (0, yup_1.string)().trim().required(REQUIRED_FIELD_MESSAGE),
});
exports.GetOptionPoolParams = (0, yup_1.object)({
    type: (0, yup_1.string)().trim().required(REQUIRED_FIELD_MESSAGE).oneOf(Object.values(enums_1.OptionGrantsType)),
});
//# sourceMappingURL=OptionPool.js.map